import React from 'react';
import AudioWorkspace from '@/components/AudioWorkspace';
import { useBusiness } from '@/prototype/context';
import type { EvidenceRef } from '@/prototype/contracts';
import { validateEvidence } from '@/prototype/domains/recording';
export default function EvidencePlayer({
  evidence,
}: {
  evidence: EvidenceRef;
}) {
  const { service } = useBusiness();
  const row = service?.get(evidence.recordingUuid);
  const version = row?.versions?.find(
    (v) => v.uuid === evidence.transcriptVersionUuid,
  );
  if (!row || !version) return null;
  try {
    validateEvidence(row, evidence);
  } catch {
    return null;
  }
  return (
    <AudioWorkspace
      key={`${row.uuid}:${version.uuid}:${evidence.startMs}:${evidence.endMs}`}
      recording={{ ...row, versions: [version] }}
      range={evidence}
      compact
    />
  );
}
